import {
  COLOR_CHART_DAILY_PATTERNS_HOVER_BORDER,
  COLOR_CHART_DEMAND_FIGURE_ELEVATED,
  COLOR_CHART_DEMAND_FIGURE_HIGH,
  COLOR_CHART_DEMAND_FIGURE_LOW,
  COLOR_CHART_DEMAND_FIGURE_NORMAL,
  COLOR_CHART_DEMAND_FIGURE_VERY_HIGH,
  COLOR_CHART_DEMAND_FIGURE_VERY_LOW,
  getCssVariableString,
  getCssVariableValue,
} from 'frontend-utils/utils/css-variable';
import {
  MI_SEARCHES_TYPE_FLIGHTS_BUSINESS,
  MI_SEARCHES_TYPE_FLIGHTS_LEISURE,
  MI_SEARCHES_TYPE_HOTELS_BUSINESS,
  MI_SEARCHES_TYPE_HOTELS_LEISURE,
} from 'lumen/utils/constants/general-constants';

// the extract date indicating "latest" is the following string
export const FIXED_EXTRACT_DATE_LATEST = 'latest';

// Hotel types
export const GRID_HOTELS_TYPE_OWN_HOTEL = 1;
export const GRID_HOTELS_TYPE_SMART_COMPSET = 2; // submarket
export const GRID_HOTELS_TYPE_OWN_COMPSET = 3; // own (primary) compset

export const DEMAND_INDEX_LEVEL_BUCKET_IDS = {
  DOW: '0,',
  YEARLY: '1,',
};

export const OUTLIER_STATUS_ACTIVE = 0;
export const OUTLIER_STATUS_DISCARDED = 1;
export const OUTLIER_STATUS_REAPPEARED = 2;

export const SHORT_TERM_RENTAL_TYPE_AIRBNB = 0;

// We currently have data in the future for 351 days
// Note: We do 365 days - 2 weeks -> some hotels have the yearly shop biweekly and the very last lead times will not have data
export const MAX_DAYS_IN_FUTURE = 351;

export const DEFAULT_DAYS_SHOWN_IN_OVERVIEW = 60;

export const SEARCHSUMMARIES_SEARCHES_LEVEL_LOWER = 1;
export const SEARCHSUMMARIES_SEARCHES_LEVEL_NORMAL = 2;
export const SEARCHSUMMARIES_SEARCHES_LEVEL_HIGHER = 3;

// Calendar view tabs
export const CALENDAR_VIEW_TABS = {
  OPPORTUNITIES: 'opportunities',
  DEMAND: 'demand',
  VERSUS7DAYSAGO: 'wowchange',
};

// Sort fields for competitors list
// snake_cased values come straight from API, camelCased values are set in frontend (rateindex model)
export const COMPETITORS_SORT_KEYS = {
  STRATEGY: 'rateIndexValue',
  PRICE: 'rate',
  SIMILARITY_SCORE: 'similarity_score',
  REVIEW_SCORE: 'review_score',
  STARS: 'stars',
  USUAL_PRICE: 'usualRate',
};

// can be used to detect calendar filters of a certain type
export const CALENDAR_FILTERS_PREFIX = {
  PRICE: 'price_',
  DEMAND: 'demand_',
};

export const CALENDAR_FILTERS = {
  PRICE_ANY: 'price_any', // Note: only used in JS logic. Should never appear as URL param
  PRICE_HIGH: 'price_high',
  PRICE_LOW: 'price_low',
  DEMAND_ANY: 'demand_any', // Note: only used in JS logic. Should never appear as URL param
  DEMAND_INCREASE: 'demand_increase',
  DEMAND_DECREASE: 'demand_decrease',
};

export const ACTIVE_FILTERS = {
  DAY: 'day',
  RANGE: 'range',
};

export const LEVEL_TO_DEMAND_COLOR_MAPPING = {
  1: getCssVariableString(COLOR_CHART_DEMAND_FIGURE_VERY_LOW),
  2: getCssVariableString(COLOR_CHART_DEMAND_FIGURE_LOW),
  3: getCssVariableString(COLOR_CHART_DEMAND_FIGURE_NORMAL),
  4: getCssVariableString(COLOR_CHART_DEMAND_FIGURE_ELEVATED),
  5: getCssVariableString(COLOR_CHART_DEMAND_FIGURE_HIGH),
  6: getCssVariableString(COLOR_CHART_DEMAND_FIGURE_VERY_HIGH),
};

// 3 constants used for the Rate preference settings, using the insightpagesfavourite model
export const MI_SETTINGS_RATE_PREFERENCE_INSIGHTPAGESFAVOURITE_NAME =
  'mi_rate_preference';

export const MI_SETTINGS_RATE_PREFERENCE_FILTER_VALUE_BEST_FLEX = 'best_flex';

export const MI_SETTINGS_RATE_PREFERENCE_FILTER_VALUE_LOWEST = 'lowest';

// Constants to define the size of the gauge charts
export const GAUGE_INNER_RADIUS = '80%';
export const GAUGE_OUTER_RADIUS = '100%';

export const OTB_TABS = {
  MY_OTB: 'my-otb',
  WOW_CHANGE: 'wow-change',
};

export const SEARCHES_TABS = {
  FLIGHTS: 'flights',
  FLIGHTSGDS: 'flightsgds',
  HOTELS: 'hotels',
  HOTELSGDS: 'hotelsgds',
};

// Used for tracking purposes (e.g. be able to send the tab names over to data analytics in places where we only have the active searches id)
export const MI_SEARCHES_TYPE_TO_SEARCHES_TAB_MAPPING = {
  [MI_SEARCHES_TYPE_FLIGHTS_LEISURE]: SEARCHES_TABS.FLIGHTS,
  [MI_SEARCHES_TYPE_FLIGHTS_BUSINESS]: SEARCHES_TABS.FLIGHTSGDS,
  [MI_SEARCHES_TYPE_HOTELS_LEISURE]: SEARCHES_TABS.HOTELS,
  [MI_SEARCHES_TYPE_HOTELS_BUSINESS]: SEARCHES_TABS.HOTELSGDS,
};

export const MI_OVERVIEW_COLUMN_CONFIG = {
  pointWidth: null, // Enables dynamic column width based on amount of bars
  maxPointWidth: 40,
  minPointLength: 3,
  states: {
    hover: {
      brightness: 0,
      borderColor: getCssVariableValue(COLOR_CHART_DAILY_PATTERNS_HOVER_BORDER),
    },
  },
};

export const DEMAND_FORECAST_SERIES_VISIBILITY_KEY = 'seriesVisibility';

export const DETAIL_PANE_DETAIL_SECTION_CARD_IDS = {
  DEMAND_INDICATORS: 'demand-indicators',
  SEARCHES: 'searches',
  PRICE_LEVEL_DISTRIBUTION: 'price-level-distribution',
  COMPETITORS_LIST: 'competitor-list',
};
